import api from "./instance";

export const getFamilyMembers = () => api.get("/staff/getallfamily");

export const createFamilyMember = (_staffId, payload) =>
  api.post("/staff/create-family", payload);

export const updateFamilyMember = (_staffId, memberId, payload) =>
  api.put("/staff/updatefamily", { familyMemberId: memberId, ...payload });

export const removeFamilyMember = (_staffId, memberId) =>
  api.delete("/staff/removefamily", { data: { familyMemberId: memberId } });
